export const isProd = window.ENV === 'PROD' || window.ENV === 'STAGE';

export function isH5() {
  return /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
}

export function eachProps(
  obj: { [prop: string]: any },
  callback: (value: any, key: string) => void
): void {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      callback(obj[prop], prop);
    }
  }
}

export function isDef(obj: any) {
  return obj !== null && obj !== undefined;
}

export function isNumber(num: any) {
  return isDef(num) && typeof num === 'number';
}

export function isFunction(fn: any) {
  return isDef(fn) && typeof fn === 'function';
}

export function isString(str: any) {
  return isDef(str) && typeof str === 'string';
}

export function isObject(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

export function isArray(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

export function checkNullObj(obj: object) {
  return isObject(obj) && Object.keys(obj).length !== 0;
}

export function getExtname(path: string) {
  return path ? path.split('.').pop() || '' : '';
}
